module.exports = __webpack_public_path__ + "static/media/Dayly_ios_5.af6f5923.jpg";